import { z } from 'zod';
export const absenceCategorySchema = z.enum([
    'vacation',
    'sickness',
    'unpaid',
    'parental',
    'long_term',
    'other',
]);
export const tempoAbsenceMappingSchema = z.object({
    planItemIds: z.array(z.string().trim().min(1).max(128)).max(100).default([]),
    items: z
        .array(z.object({ planItemId: z.string().trim().min(1).max(128), category: absenceCategorySchema }))
        .max(100)
        .default([]),
});
export const sourceFreshnessSchema = z.object({
    lastSuccessAt: z.iso.datetime().nullable(),
    lastAttemptAt: z.iso.datetime().nullable(),
    state: z.enum(['unconfigured', 'fresh', 'stale', 'running', 'failed']),
    stale: z.boolean().default(false),
});
export const resourceSourcesSchema = z.object({
    jira: sourceFreshnessSchema,
    tempo: sourceFreshnessSchema,
});
export const tempoTeamSchema = z.object({
    id: z.string().min(1),
    name: z.string(),
    active: z.boolean(),
    synchronizedAt: z.iso.datetime(),
    members: z.array(z.object({ resourceId: z.uuid(), name: z.string(), roleName: z.string().nullable() })),
});
export const tempoTeamsResponseSchema = z.object({
    data: z.array(tempoTeamSchema),
    meta: z.object({
        freshness: sourceFreshnessSchema,
        available: z.boolean().nullable().default(null),
    }),
});
export const integrationProviderControlSchema = z.object({
    provider: z.enum(['jira', 'tempo', 'hubspot']),
    configured: z.boolean(),
    enabled: z.boolean(),
    updatedAt: z.iso.datetime().nullable(),
});
export const integrationProviderControlInputSchema = z.object({
    enabled: z.boolean(),
});
export const projectActivityStateSchema = z.object({
    lastActivityAt: z.iso.datetime().nullable(),
    inactivityThresholdDays: z.number().int().positive(),
    stale: z.boolean(),
    reason: z.enum(['recent', 'threshold_exceeded', 'never_observed']),
});
export const tempoAbsenceSettingsResponseSchema = z.object({
    data: tempoAbsenceMappingSchema.extend({ available: z.boolean().nullable() }),
});
export const tempoWorklogAbsencesSettingsResponseSchema = z.object({
    data: z.object({
        source: z.literal('timesheets'),
        issueKeys: z.array(z.string()),
        available: z.boolean().nullable(),
        lastSuccessAt: z.iso.datetime().nullable(),
    }),
});
//# sourceMappingURL=integrations.js.map